import { render, staticRenderFns } from "./T1PrzewodnikTurystycznyContent.vue?vue&type=template&id=8e5f89b6&scoped=true&"
import script from "./T1PrzewodnikTurystycznyContent.vue?vue&type=script&lang=js&"
export * from "./T1PrzewodnikTurystycznyContent.vue?vue&type=script&lang=js&"
import style0 from "./T1PrzewodnikTurystycznyContent.vue?vue&type=style&index=0&id=8e5f89b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5f89b6",
  null
  
)

export default component.exports